import Overlay from "./Overlay";
import Navbar from './Navbar';
import { useState } from 'react';
import { FILESYSTEM_NAME, } from './Filesystem';
import { getImageSetAnnotationsAsFilesystemItems } from './FilesystemComponentFunctions';
import G from './Getters';
import { CREATION_DATE, LAST_EDITED_DATE } from './FieldConstants';
import FilesystemListContainer from './FilesystemListContainer';
//
import { IMAGE_SETS, ANNOTATIONS } from './RecordTypes';

import { FilesystemHierarchyContext, FilesystemStore } from './Contexts';
import ProteinTargetSearchContainer from './ProteinTargetSearchContainer';
import usePresentSelector from './usePresentSelector';
import { useContext } from 'react';
import { CropDragContext } from './CropDragProvider';

const options = [{_id:"filesystem",label:"Filesystem View"}, {_id:"list",label:"List View"}];

export default function CropInsertionSelector({
  setMode 
}){

  let cropDragContext = useContext(CropDragContext);
  let cropIdsSelectedForInsertion = cropDragContext.cropIdsBeingDragged
  let setCropIdsSelectedForInsertion = cropDragContext.setCropIdsBeingDragged;

  const [ selectedNavbarOption, setSelectedNavbarOption ] = useState("list")//"filesystem")//"list");


  const topLevelDirectoryId = usePresentSelector(state => G.getTopLevelDirectoryId(state,{itemType:"imageSets"}));

  let proteinSearchBarWidth = ({ filesystem:300, list:200 })[selectedNavbarOption];

  const isThisCropSelectedForInsertion = (_id) => {
    return cropIdsSelectedForInsertion.find(item => item.annotationId === (_id))
  }

  const [ actionLoc, setActionLoc ] = useState();



  const cropFilesystemView =  (
    <div class="relative sg-col" style={{
      minHeight:0,
      height:'100%',
      width:proteinSearchBarWidth,
    }}>
            

      <FilesystemStore.Provider value={{
        isFilesystemItemSelected:(_id) => {
          return !!isThisCropSelectedForInsertion(_id)
        },
        onFilesystemItemEvent:({_id,event, item}) => {
          if( item.type === ANNOTATIONS ){

            //console.log(event.nativeEvent);

            if( event.nativeEvent.shiftKey ){
             // console.log("Shift key was down on selection!");

              let alreadySelected = isThisCropSelectedForInsertion(_id);
              if( alreadySelected ){
                setCropIdsSelectedForInsertion(cropIdsSelectedForInsertion.filter(x => x.annotationId === _id));
              }else{
                setCropIdsSelectedForInsertion([
                  ...cropIdsSelectedForInsertion,
                  {valueType:'crop',annotationId:_id}
                ])
              }
            }else{
              setCropIdsSelectedForInsertion([{valueType:'crop', annotationId:_id}])
            }
          }else if( item.type === IMAGE_SETS ){

            debugger;
            setActionLoc([event.clientX,event.clientY]);

            let virtualNodeCreator = imageSetId => `v_t=atn;geo=full;is=${imageSetId}`;
            let annotationId = virtualNodeCreator(_id);
            setCropIdsSelectedForInsertion([{valueType:"crop",annotationId}]);
          }
        }

      }}>
        <FilesystemHierarchyContext.Provider value={{

          [IMAGE_SETS]:(state,_id) => {
            let children = getImageSetAnnotationsAsFilesystemItems(state,_id);
            let expandable = children.length > 0;
            return { children, expandable };
          },
          [ANNOTATIONS]:(state,_id) => {
            return {children:[],expandable:false}
          }

        }}>

          <FilesystemListContainer {...{
            filesystemContainer:"crops",
            topLevelDirectoryId,
            columns:[
              FILESYSTEM_NAME,
              LAST_EDITED_DATE,
            ]

          }}/>

          {actionLoc && false && (<Overlay onClose={() => setActionLoc()} 
            style={{
              left:actionLoc[0],
              top:actionLoc[1],
              transform:'translate(5px,-50%)',
            }}>
            <div onClick={() => {

            }}>
              this is an action overlay
            </div>
          </Overlay>
          )}

        </FilesystemHierarchyContext.Provider>
      </FilesystemStore.Provider>

    </div>
  )

  const cropListView = (
        <div style={{
          height:'100%',
          minHeight:0,
          width:proteinSearchBarWidth,
        }}>


          <ProteinTargetSearchContainer {...{
            setMode,
            isThisCropSelectedForInsertion,
            isSomeCropSelectedForInsertion:cropIdsSelectedForInsertion?.length > 0,
            setCropIdsSelectedForInsertion,
            
          }}/>
        </div>
      )


  const selector = ({filesystem:cropFilesystemView,list:cropListView})[selectedNavbarOption];


  return (
    <div class="full-height sg-col" style={{
      minHeight:0,
      position:'relative',
      }}>
      {true && <Navbar options={options} selected={selectedNavbarOption} onSelect={setSelectedNavbarOption}/>}
      {selector}
    </div>
  )

}
